import { render } from "./placement.vue?vue&type=template&id=25d68dce"
import script from "./placement.vue?vue&type=script&lang=js"
export * from "./placement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__